import undoable, { excludeAction } from "redux-undo";

const removeKey = (key, { [key]: _, ...rest }) => rest;

const analysisReducer = (state = {}, action) => {
  switch (action.type) {
    case "CREATE_ANALYSIS": {
      return {
        ...state,
        create_analysis_result: action.payload,
        analysis_id: action.payload.data.analysis_id,
      };
    }
    case "CLEAR_CREATE_ANALYSIS_RESULT": {
      return {
        ...state,
        create_analysis_result: null,
        // analysis_id: null,
      };
    }
    case "UPLOAD_FILES": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: action.payload.res,
        },
      };
    }
    case "SET_EXTRACTED_DATA": {
      return {
        ...state,
        extracted_data: action.payload,
      };
    }
    case "ADD_ENTITIE": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            ...state.extracted_data[action.payload.step_index],
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: [
                ...Object.values(state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities),
                ...[
                  {
                    flow_category: { id: 1, name: "K_Transports", title: "de transport", unit: "Kg" },
                    weight: {
                      mentionText: null,
                      confidence: null,
                    },
                    distance: {
                      rows: [
                        {
                          elements: [
                            {
                              distance: {
                                text: 0,
                              },
                            },
                          ],
                        },
                      ],
                    },
                    price: {
                      mentionText: null,
                      confidence: null,
                    },
                  },
                ],
              ],
            },
          },
        },
      };
    }

    case "REMOVE_ENTITE": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: removeKey(action.payload.index, state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities),
            },
          },
        },
      };
    }

    case "SET_ENTITIE_CATEGORY": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            ...state.extracted_data[action.payload.step_index],
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: {
                ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities,
                0: {
                  ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0],
                  flow_category: {
                    id: action.payload.id,
                    name: action.payload.name,
                    title: action.payload.title,
                    unit: action.payload.unit,
                  },
                },
              },
            },
          },
        },
      };
    }

    case "SET_ENTITIE_FLOW": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            ...state.extracted_data[action.payload.step_index],
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: {
                ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities,
                0: {
                  ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0],
                  flow_type: {
                    id: action.payload.id,
                    name: action.payload.name,
                    step_index: action.payload.step_index,
                  },
                },
              },
            },
          },
        },
      };
    }

    case "UPDATE_DOCUMENT_DISTANCE_LOCAL": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            ...state.extracted_data[action.payload.step_index],
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: {
                ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities,
                0: {
                  ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0],
                  distance: {
                    ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0].distance,
                    rows: [
                      {
                        elements: [
                          {
                            distance: {
                              text: action.payload.distance,
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      };
    }

    case "UPDATE_DOCUMENT_WEIGHT_LOCAL": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            ...state.extracted_data[action.payload.step_index],
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: {
                ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities,
                0: {
                  ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0],
                  weight: {
                    ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0].weight,
                    mentionText: action.payload.weight,
                  },
                },
              },
            },
          },
        },
      };
    }

    case "UPDATE_DOCUMENT_PRICE_LOCAL": {
      return {
        ...state,
        extracted_data: {
          ...state.extracted_data,
          [action.payload.step_index]: {
            ...state.extracted_data[action.payload.step_index],
            [action.payload.elem_index]: {
              ...state.extracted_data[action.payload.step_index][action.payload.elem_index],
              selected_entities: {
                ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities,
                0: {
                  ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0],
                  price: {
                    ...state.extracted_data[action.payload.step_index][action.payload.elem_index].selected_entities[0].price,
                    mentionText: action.payload.price,
                  },
                },
              },
            },
          },
        },
      };
    }

    case "REMOVE_ANALYSIS": {
      return state;
    }
    case "REMOVE_ANALYSIS_LOCAL": {
      return {
        ...state,
        analysis_history: removeKey(action.payload, state.analysis_history),
        analysis_history_filtred: removeKey(action.payload, state.analysis_history_filtred),
      };
    }

    case "SET_ANALYSIS_ID": {
      return {
        ...state,
        analysis_id: action.payload,
      };
    }

    case "FETCH_ANALYSIS": {
      return {
        ...state,
        analysis_data: action.payload.data,
        loading: action.payload.loading,
      };
    }

    case "SET_ANALYSIS": {
      return {
        ...state,
        analysis_data: action.payload.data,
        loading: action.payload.loading,
      };
    }

    case "FETCH_ANALYSIS_HISTORY": {
      return {
        ...state,
        analysis_history: action.payload.history,
        analysis_history_filtred: action.payload.history,
        loading: action.payload.loading,
      };
    }

    case "SET_ANALYSIS_HISTORY_FILTRED": {
      return {
        ...state,
        analysis_history_filtred: action.payload.history,
        loading: action.payload.loading,
      };
    }

    case "CALCUL_ECO_SCORE": {
      return state;
    }

    case "FETCH_IMPACT_INDICATORS": {
      return {
        ...state,
        impact_indicators: action.payload,
      };
    }

    case "SET_PRODUCT_NAME_LOCAL": {
        return {
          ...state,
          analysis_data: {
            ...state.analysis_data,
            lca: {
              ...state.analysis_data.lca,
              lca_steps: {
                ...state.analysis_data.lca.lca_steps,
                [action.payload.index]: {
                  ...state.analysis_data.lca.lca_steps[action.payload.index],
                  ciqual_name: {
                    // ...state.analysis_data.lca.lca_steps[action.payload.index].ciqual_name,
                    // fr: 'toto'
                    fr: action.payload.item,
                    en: action.payload.item,
                  },
                }
              },
            },
          },
        };
    }
    case "SET_PRODUCT_NAME": {
      return state;
    }


    // UNDO REDO CONTOLLERS
    case "SET_REMOTE_UNDO_TO_UPDATE_ITEM": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload,
      };
    }
    case "UPDATE_REMOTE_UNDO_ITEM": {
      return state;
    }
    case "UPDATE_REMOTE_REDO_ITEM": {
      return state;
    }
    // CHECKED
    case "SET_CHECKED_FLOW": {
      return state;
    }
    case "SET_CHECKED_FLOW_LOCAL": {
      if (action.payload.item.is_proxy) {
        return {
          ...state,
          remote_undo_to_update_item: action.payload.item,
          analysis_data: {
            ...state.analysis_data,
            lca: {
              ...state.analysis_data.lca,
              lca_steps: {
                ...state.analysis_data.lca.lca_steps,
                [action.payload.item.step_index]: {
                  ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                  outputs: {
                    ...state.analysis_data.lca.lca_steps[action.payload.item.step_index].outputs,
                    0: {
                      ...state.analysis_data.lca.lca_steps[action.payload.item.step_index].outputs[0],
                      checked: action.payload.item.value,
                    },
                  },
                },
              },
            },
          },
        };
      } else {
        if (action.payload.item.k_type === "K_Wastes") {
          return {
            ...state,
            remote_undo_to_update_item: action.payload.item,
            analysis_data: {
              ...state.analysis_data,
              lca: {
                ...state.analysis_data.lca,
                lca_steps: {
                  ...state.analysis_data.lca.lca_steps,
                  [action.payload.item.step_index]: {
                    ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                    outputs: {
                      ...Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index].outputs,
                      [action.payload.item.process_id]: {
                        ...Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index].outputs[action.payload.item.process_id],
                        checked: action.payload.item.value,
                      },
                    },
                  },
                },
              },
            },
          };
        } else {
          return {
            ...state,
            remote_undo_to_update_item: action.payload.item,
            analysis_data: {
              ...state.analysis_data,
              lca: {
                ...state.analysis_data.lca,
                lca_steps: {
                  ...state.analysis_data.lca.lca_steps,
                  [action.payload.item.step_index]: {
                    ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                    inputs: {
                      ...Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index].inputs,
                      [action.payload.item.process_id]: {
                        ...Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index].inputs[action.payload.item.process_id],
                        checked: action.payload.item.value,
                      },
                    },
                  },
                },
              },
            },
          };
        }
      }
    }
    case "SET_ALL_CHECKED": {
      return state;
    }
    case "SET_ALL_CHECKED_LOCAL": {
      if (state.analysis_history) {
        return {
          ...state,
          analysis_history: {
            ...state.analysis_history,
            [action.payload.analysis_id]: {
              ...state.analysis_history[action.payload.analysis_id],
              status: action.payload.status,
            },
          },
        };
      }
    }

    // PALM-OIL
    case "UPDATE_PALM_OIL": {
      return state;
    }
    case "UPDATE_PALM_OIL_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          // eco_packaging: state.analysis_data.eco_packaging ? [...state.analysis_data.eco_packaging, action.payload.item.value] : [action.payload.item.value],
          palm_oil: action.payload.item.value,
        },
      };
    }

    // ECO-PACKAGING
    case "ADD_ECO_PACKAGING": {
      return state;
    }
    case "ADD_ECO_PACKAGING_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          // eco_packaging: state.analysis_data.eco_packaging ? [...state.analysis_data.eco_packaging, action.payload.item.value] : [action.payload.item.value],
          eco_packaging: {
            ...state.analysis_data.eco_packaging,
            [action.payload.item.eco_packaging_remote_key]: action.payload.item.value,
          },
        },
      };
    }
    case "REMOVE_ECO_PACKAGING": {
      return state;
    }
    case "REMOVE_ECO_PACKAGING_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          eco_packaging: removeKey(action.payload.item.value[0], state.analysis_data.eco_packaging),
          // [
          //   ...Object.values(state.analysis_data.eco_packaging).slice(0, action.payload.item.eco_packaging_id),
          //   ...Object.values(state.analysis_data.eco_packaging).slice(action.payload.item.eco_packaging_id + 1),
          // ],
        },
      };
    }
    case "UPDATE_ECO_PACKAGING_FORMAT": {
      return state;
    }
    case "UPDATE_ECO_PACKAGING_FORMAT_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          // eco_packaging: state.analysis_data.eco_packaging ? [...state.analysis_data.eco_packaging, action.payload.item.value] : [action.payload.item.value],
          eco_packaging: {
            ...state.analysis_data.eco_packaging,
            // [action.payload.item.eco_packaging_remote_key]: action.payload.item.value,
            [action.payload.item.eco_packaging_remote_key]: {
              ...state.analysis_data.eco_packaging[action.payload.item.eco_packaging_remote_key],
              format: action.payload.item.value,
            },
          },
        },
      };
    }
    case "UPDATE_ECO_PACKAGING_MATERIAL": {
      return state;
    }
    case "UPDATE_ECO_PACKAGING_MATERIAL_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          // eco_packaging: state.analysis_data.eco_packaging ? [...state.analysis_data.eco_packaging, action.payload.item.value] : [action.payload.item.value],
          eco_packaging: {
            ...state.analysis_data.eco_packaging,
            // [action.payload.item.eco_packaging_remote_key]: action.payload.item.value,
            [action.payload.item.eco_packaging_remote_key]: {
              ...state.analysis_data.eco_packaging[action.payload.item.eco_packaging_remote_key],
              material: action.payload.item.value,
            },
          },
        },
      };
    }

    // FORMAT
    case "FETCH_FORMATS": {
      return {
        ...state,
        formats: action.payload,
      };
    }

    // MATERIALS
    case "FETCH_MATERIALS": {
      return {
        ...state,
        materials: action.payload,
      };
    }

    // LABELS
    case "FETCH_LABELS": {
      return {
        ...state,
        labels: action.payload,
      };
    }
    case "ADD_LABEL": {
      return state;
    }
    case "ADD_LABEL_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          // labels: state.analysis_data.labels ? [...state.analysis_data.labels, action.payload.item.label] : [action.payload.item.label],
          labels: {
            ...state.analysis_data.labels,
            [action.payload.item.label_remote_key]: action.payload.item.label,
          },
        },
      };
    }
    case "REMOVE_LABEL": {
      return state;
    }
    case "REMOVE_LABEL_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          labels: removeKey(action.payload.item.label_remote_key, state.analysis_data.labels),
          // labels: [...Object.values(state.analysis_data.labels).slice(0, action.payload.item.label_id), ...Object.values(state.analysis_data.labels).slice(action.payload.item.label_id + 1)],
        },
      };
    }

    // QUANTITY TABLE
    case "UPDATE_QUANTITY_TABLE_REMOTE": {
      return state;
    }
    case "UPDATE_QUANTITY_TABLE_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      if (action.payload.item.is_proxy) {
        return {
          ...state,
          remote_undo_to_update_item: action.payload.item,
          analysis_data: {
            ...state.analysis_data,
            lca: {
              ...state.analysis_data.lca,
              lca_steps: {
                ...state.analysis_data.lca.lca_steps,
                [action.payload.item.step_index]: {
                  ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                  outputs: {
                    ...state.analysis_data.lca.lca_steps[action.payload.item.step_index].outputs,
                    0: {
                      ...state.analysis_data.lca.lca_steps[action.payload.item.step_index].outputs[0],
                      amount: action.payload.item.quantity,
                    },
                  },
                },
              },
            },
          },
        };
      } else {
        return {
          ...state,
          analysis_data: {
            ...state.analysis_data,
            lca: {
              ...state.analysis_data.lca,
              lca_steps: {
                ...state.analysis_data.lca.lca_steps,
                [action.payload.item.step_index]: {
                  ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                  [action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"]: {
                    ...Object.values(
                      Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                        action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                      ]
                    ),
                    [action.payload.item.process_id]: {
                      ...Object.values(
                        Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                          action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                        ]
                      )[action.payload.item.process_id],
                      amount: action.payload.item.quantity,
                    },
                  },
                },
              },
            },
          },
        };
      }
    }

    // INGREDIENT ORIGIN
    case "UPDATE_ORIGIN_QUANTITY_REMOTE": {
      return state;
    }
    case "UPDATE_ORIGIN_QUANTITY_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs,
                  [action.payload.item.index_origin]: {
                    ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs)[action.payload.item.index_origin],
                    amount: action.payload.item.quantity,
                  },
                },
              },
            },
          },
        },
      };
    }
    case "UPDATE_ORIGIN_VALUE_REMOTE": {
      return state;
    }
    case "UPDATE_ORIGIN_VALUE_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs,
                  [action.payload.item.index_origin]: {
                    ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs)[action.payload.item.index_origin],
                    origin: action.payload.item.quantity,
                  },
                },
              },
            },
          },
        },
      };
    }

    case "UPDATE_ORIGIN_TRANSPORT_VALUE_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.tranport_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.tranport_raw_id],
                inputs: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.tranport_raw_id].inputs,
                  [action.payload.item.index_transport]: {
                    ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.tranport_raw_id].inputs[action.payload.item.index_transport],
                    description: "Transport for " + action.payload.item.quantity + " import",
                  },
                },
              },
            },
          },
        },
      };
    }

    case "ADD_ORIGIN": {
      return state;
    }
    case "ADD_ORIGIN_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      if (action.payload.item.index_raw_id) {
        return {
          ...state,
          // remote_undo_to_update_item: action.payload.item,
          analysis_data: {
            ...state.analysis_data,
            ingredients: {
              ...state.analysis_data.ingredients,
              [action.payload.item.flow_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id],
                [action.payload.item.index_raw_id]: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                  inputs: [
                    ...(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs
                      ? Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs)
                      : []),
                    action.payload.item.data,
                  ],
                },
              },
            },
          },
        };
      } else {
        return {
          ...state,
          remote_undo_to_update_item: action.payload.item,
          analysis_data: {
            ...state.analysis_data,
            ingredients: {
              ...state.analysis_data.ingredients,
              [action.payload.item.flow_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id],
                [Object.values(state.analysis_data["ingredients"][action.payload.item.flow_id]).length]: action.payload.item.transport_data,
                [Object.values(state.analysis_data["ingredients"][action.payload.item.flow_id]).length + 1]: action.payload.item.raw_data,
              },
            },
          },
        };
      }
    }
    case "REMOVE_ORIGIN": {
      return state;
    }
    case "REMOVE_ORIGIN_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs:
                  Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs).length === 1
                    ? []
                    : [
                        ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs).slice(0, action.payload.item.transport_id),
                        ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs).slice(action.payload.item.transport_id + 1),
                      ],
              },
            },
          },
        },
      };
    }

    case "REMOVE_ORIGIN_TRANSPORT_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.tranport_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.tranport_raw_id],
                inputs: [
                  ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.tranport_raw_id].inputs).slice(0, action.payload.target_id),
                  ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.tranport_raw_id].inputs).slice(action.payload.target_id + 1),
                ],
              },
            },
          },
        },
      };
    }

    // INGREDIENT TRANSPORT
    case "UPDATE_INGREDIENT_TRANSPORT": {
      return state;
    }
    case "UPDATE_INGREDIENT_TRANSPORT_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs,
                  [action.payload.item.index_transport]: action.payload.data,
                },
              },
            },
          },
        },
      };
    }
    case "UPDATE_INGREDIENT_TRANSPORT_QUANTITY_REMOTE": {
      return state;
    }
    case "UPDATE_INGREDIENT_TRANSPORT_QUANTITY_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs,
                  [action.payload.item.index_transport]: {
                    // ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs)[action.payload.item.index_transport],
                    ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs[action.payload.item.index_transport],
                    amount: action.payload.item.quantity,
                  },
                },
              },
            },
          },
        },
      };
    }
    case "ADD_INGREDIENT_TRANSPORT": {
      return state;
    }
    case "ADD_INGREDIENT_TRANSPORT_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: [...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs), action.payload.item.data],
              },
            },
          },
        },
      };
    }
    case "REMOVE_INGREDIENT_TRANSPORT": {
      return state;
    }
    case "REMOVE_INGREDIENT_TRANSPORT_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: [
                  ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs).slice(0, action.payload.item.transport_id),
                  ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs).slice(action.payload.item.transport_id + 1),
                ],
              },
            },
          },
        },
      };
    }

    case "UPDATE_INGREDIENT_TRANSPORT_ORIGIN_REMOTE": {
      return state;
    }
    case "UPDATE_INGREDIENT_TRANSPORT_ORIGIN_LOCAL": {
      // immutable patterns https://redux.js.org/usage/structuring-reducers/immutable-update-patterns
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_id]: {
              ...state.analysis_data.ingredients[action.payload.item.flow_id],
              [action.payload.item.index_raw_id]: {
                ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id],
                inputs: {
                  ...state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs,
                  [action.payload.item.index_transport]: {
                    ...Object.values(state.analysis_data.ingredients[action.payload.item.flow_id][action.payload.item.index_raw_id].inputs)[action.payload.item.index_transport],
                    description: "Transport for " + action.payload.item.quantity + " import.",
                  },
                },
              },
            },
          },
        },
      };
    }

    // FLOW
    case "UPDATE_FLOW_REMOTE": {
      return state;
    }
    case "UPDATE_FLOW_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                inputs: {
                  ...state.analysis_data.lca.lca_steps[action.payload.item.step_index].inputs,
                  [action.payload.item.process_id]: action.payload.data,
                },
              },
            },
          },
        },
      };
    }
    case "UPDATE_FLOW_QUANTITY_REMOTE": {
      return state;
    }
    case "UPDATE_FLOW_QUANTITY_LOCAL": {
      return {
        ...state,
        analysis_data: {
          ...state.analysis_data,
          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                [action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"]: {
                  ...Object.values(
                    Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                      action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                    ]
                  ),
                  [action.payload.item.process_id]: {
                    ...Object.values(
                      Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                        action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                      ]
                    )[action.payload.item.process_id],
                    amount: action.payload.item.quantity,
                  },
                },
              },
            },
          },
        },
      };
    }
    case "UPDATE_FLOW_DESCRIPTION": {
      return state;
    }
    case "UPDATE_FLOW_DESCRIPTION_LOCAL": {
      return {
        ...state,
        analysis_data: {
          ...state.analysis_data,
          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                [action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"]: {
                  ...state.analysis_data.lca.lca_steps[action.payload.item.step_index][
                    action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                  ],
                  [action.payload.item.process_id]: {
                    ...Object.values(
                      Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                        action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                      ]
                    )[action.payload.item.process_id],
                    description_fr: action.payload.item.value,
                    description: action.payload.item.value,
                  },
                },
              },
            },
          },
        },
      };
    }
    case "ADD_FLOW_TO_STEP_REMOTE": {
      return state;
    }
    case "ADD_FLOW_TO_STEP_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                [action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"]: [
                  ...(Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                    action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                  ]
                    ? Object.values(
                        Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index][
                          action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"
                        ]
                      )
                    : []),
                  action.payload.item.data,
                ],
              },
            },
          },
        },
      };
    }
    case "REMOVE_FLOW_FROM_STEP": {
      return state;
    }
    case "REMOVE_FLOW_FROM_STEP_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                // inputs: [
                //   // ...state.analysis_data.lca.lca_steps[
                //   ...Object.values(state.analysis_data.lca.lca_steps[action.payload.item.step_index].inputs).slice(0, action.payload.item.process_id),
                //   ...Object.values(state.analysis_data.lca.lca_steps[action.payload.item.step_index].inputs).slice(action.payload.item.process_id + 1),
                // ],
                [action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"]: removeKey(
                  action.payload.item.process_id,
                  Object.assign(
                    {},
                    state.analysis_data.lca.lca_steps[action.payload.item.step_index][action.payload.item.k_type === "K_Wastes" || action.payload.item.k_type === "K_Food_Given" ? "outputs" : "inputs"]
                  )
                ),
              },
            },
          },
        },
      };
    }
    case "REMOVE_INGREDIENT": {
      return state;
    }
    case "REMOVE_INGREDIENT_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          // ingredients: Object.keys(state.analysis_data.ingredients).reduce((object, key) => {
          //   if (key !== action.payload.item.flow_id) {
          //     object[key] = state.analysis_data.ingredients[key];
          //   }
          //   return object;
          // }, {}),
          ingredients: removeKey(action.payload.item.flow_id, Object.assign({}, state.analysis_data.ingredients)),

          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                inputs: removeKey(action.payload.item.process_id, Object.assign({}, Object.values(state.analysis_data.lca.lca_steps[action.payload.item.step_index].inputs))),

                // [
                //   ...Object.values(state.analysis_data.lca.lca_steps[action.payload.item.step_index].inputs).slice(0, action.payload.item.process_id),
                //   ...Object.values(state.analysis_data.lca.lca_steps[action.payload.item.step_index].inputs).slice(action.payload.item.process_id + 1),
                // ],
              },
            },
          },
        },
      };
    }
    case "ADD_INGREDIENT": {
      return state;
    }
    case "ADD_INGREDIENT_LOCAL": {
      return {
        ...state,
        remote_undo_to_update_item: action.payload.item,
        analysis_data: {
          ...state.analysis_data,
          ingredients: {
            ...state.analysis_data.ingredients,
            [action.payload.item.flow_uid]: action.payload.item.ingredient_data,
          },
          lca: {
            ...state.analysis_data.lca,
            lca_steps: {
              ...state.analysis_data.lca.lca_steps,
              [action.payload.item.step_index]: {
                ...state.analysis_data.lca.lca_steps[action.payload.item.step_index],
                inputs: [...Object.values(Object.values(state.analysis_data.lca.lca_steps)[action.payload.item.step_index].inputs), action.payload.item.lca_data],
              },
            },
          },
        },
      };
    }

    default:
      return state;
  }
};

// const undoableAnalysisReducer = undoable(analysisReducer, {
//   filter: excludeAction([
//     "CREATE_ANALYSIS",
//     "FETCH_LABELS",
//     "FETCH_MATERIALS",
//     "FETCH_FORMATS",
//     "SET_CHECKED_FLOW",
//     "SET_CHECKED_FLOW_LOCAL",
//     "SET_ALL_CHECKED",
//     "SET_ALL_CHECKED_LOCAL",
//     "CLEAR_CREATE_ANALYSIS_RESULT",
//     "SET_ANALYSIS_ID",
//     "SET_ANALYSIS",
//     "FETCH_ANALYSIS",
//     "FETCH_ANALYSIS_HISTORY",
//     "SET_ANALYSIS_HISTORY_FILTRED",
//     "FETCH_IMPACT_INDICATORS",
//     "CALCUL_ECO_SCORE",
//   ]),
// });

export default analysisReducer;
